import React from 'react';
import styled from 'styled-components';

type PlaceholderTextProps = {
    children: React.ReactNode;
};

const Root = styled.div`
    padding: 1rem;
    width: 100%;
    font-size: 2.6rem;
`;

const PlaceholderText = (props: PlaceholderTextProps) => {
    const { children } = props;

    return <Root>{children}</Root>;
};

export { PlaceholderText };
